'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _ossUploadHelper = require('../../common/oss-upload-helper');

var _lodash = require('lodash');

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var BatchImportButton = (_temp = _class = function (_Component) {
  _inherits(BatchImportButton, _Component);

  function BatchImportButton(props) {
    _classCallCheck(this, BatchImportButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onFileUploadComplete = function (file, value) {
      var _this$props = _this.props,
          params = _this$props.params,
          url = _this$props.url,
          getFormData = _this$props.getFormData;
      var _file$originFileObj = file.originFileObj,
          ossUrl = _file$originFileObj.ossUrl,
          uuidName = _file$originFileObj.uuidName,
          fileKey = _file$originFileObj.fileKey;

      (0, _ossUploadHelper.registerFile)(uuidName, fileKey);

      _service2.default.head(ossUrl).then(function () {
        // issue 34393442
        var formData = getFormData && getFormData();
        return (0, _service.upload)(url, _extends({}, params, { formData: formData, uploadFileOssUrl: ossUrl }));
      }).then(function () {
        (0, _service.uploadStatusQuery)(params, {
          onError: _this.onTaskError,
          onSuccess: _this.onTaskSuccess,
          onProgress: _this.onTaskProgress
        });
      }).catch(function (err) {
        _this.setState({
          uploading: false
        });
        var message = '上传失败';
        if (err) {
          if (err.message || err.errorMsg) {
            message = err.message || err.errorMsg;
          } else if (typeof err === 'string') {
            message = err;
          }
        }
        _next.Message.error({ title: message, duration: 2000 });
      });
    };

    _this.onTaskProgress = function (data) {
      if (!data) {
        return;
      }
      var total = data.total,
          guessTotalRows = data.guessTotalRows;

      if (typeof total !== 'number' || typeof guessTotalRows !== 'number' || guessTotalRows === 0) {
        return;
      }

      var progress = parseInt(total * 100 / guessTotalRows);
      _this.setState({
        uploading: true,
        uploadingProgress: progress
      });
    };

    _this.onTaskError = function (e) {
      e && e.errorMsg && _next.Message.error(e && e.errorMsg);
      _this.setState({
        uploading: false
      });
    };

    _this.onTaskSuccess = function (data) {
      var onSuccess = _this.props.onSuccess;
      var reportFileUrl = data.reportFileUrl,
          succeed = data.succeed,
          total = data.total,
          reportMessage = data.reportMessage,
          normalTableData = data.normalTableData;

      _this.setState({
        failMsg: {
          show: true,
          reportFileUrl: reportFileUrl,
          succeed: succeed,
          total: total,
          reportMessage: reportMessage
        },
        uploading: false
      });
      if (!(0, _lodash.isEmpty)(reportMessage)) {
        _next.Message.error({ title: reportMessage, duration: 2000 });
      }
      // if (succeed < 1) {
      //   return;
      // }
      onSuccess && onSuccess(normalTableData);
    };

    _this.state = {
      uploading: false,
      uploadingProgress: 0,
      failMsg: {}
    };
    return _this;
  }

  BatchImportButton.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        showMsg = _props.showMsg,
        onUpload = _props.onUpload,
        global = _props.global;
    var _state = this.state,
        uploading = _state.uploading,
        uploadingProgress = _state.uploadingProgress,
        failMsg = _state.failMsg;

    return _react2.default.createElement(
      'div',
      { style: { display: 'inline-block' } },
      _react2.default.createElement(
        _next.Upload,
        {
          type: 'file',
          accept: '.xls,.xlsx',
          style: { display: 'inline-block' },
          onSuccess: this.onFileUploadComplete,
          formatter: _ossUploadHelper.uploadResultFormatter,
          onError: this.onTaskError,
          beforeUpload: function beforeUpload(file, options) {
            _this2.setState({
              uploading: true,
              uploadingProgress: 0,
              failMsg: {
                show: false
              }
            });
            onUpload();
            return (0, _ossUploadHelper.beforeUpload)(file, options, _extends({}, (0, _lodash.get)(global, 'formOptions', {})));
          }
        },
        _react2.default.createElement(
          _next.Button,
          { type: 'secondary' },
          _react2.default.createElement(_next.Icon, { type: 'upload' }),
          ' \u6279\u91CF\u5BFC\u5165'
        )
      ),
      uploading && _react2.default.createElement(_next.Progress, { percent: uploadingProgress, style: { width: 200 } }),
      showMsg && failMsg.show && (failMsg.reportFileUrl ? _react2.default.createElement(
        'a',
        { href: failMsg.reportFileUrl, target: '_blank', 'class': 'vc-gov-big-table-upload-error-text' },
        '\u5171\u8BA1 ',
        failMsg.total,
        ' \u884C \u6210\u529F ',
        failMsg.succeed,
        ' \u884C \u70B9\u51FB\u4E0B\u8F7D\u9519\u8BEF\u6570\u636E'
      ) : _react2.default.createElement(
        _next.Button,
        { text: true },
        '\u5171\u8BA1',
        failMsg.total,
        '\u884C, \u65B0\u589E',
        failMsg.succeed,
        ', \u89E3\u6790\u5B8C\u6210'
      ))
    );
  };

  return BatchImportButton;
}(_react.Component), _class.defaultProps = {
  url: '/form/table/upload',
  showMsg: true,
  onUpload: function onUpload() {}
}, _temp);
exports.default = BatchImportButton;
module.exports = exports['default'];